'use client';

import { cn } from '@ngg/storefront-utils';
import type { ReactNode } from 'react';

interface Props {
  children: ReactNode;
  className?: string;
}

export default function RoundBadge({ children, className }: Props) {
  return (
    <span
      className={cn(
        'inline-flex min-h-[16px] min-w-[16px] items-center justify-center rounded-full bg-black px-1',
        'text-xxs font-bold leading-none text-white',
        className,
      )}>
      {children}
    </span>
  );
}
